/**
 * Controller for GPS map
 * @requires {Object} applicationModel
 * @requires {Object} configService
 * @requires {Object} eventTypeService
 * @requires {Object} $scope
 * @requires {Function} $timeout
 */

function gpsMapController(
  applicationModel,
  configService,
  eventTypeService,
  tealiumService,
  $scope,
  $timeout
) {

  const vm = this;
  // Map variables
  let defaultPin;
  let map;
  let infobox;

  /**
   * Gets the GPS toggle class
   * @param {Boolean} state
   * @returns {String}
   */
  function getGPSToggleClass(state) {

    return state ? 'expanded' : 'collapsed';

  }

  /**
   * Set Map focus
   */
  function setMapFocus() {

    const mapElement = document.getElementById('gps-container');
    mapElement.scrollIntoView({ block: 'center' });
    mapElement.focus();

  }

  /**
   * Wait to load map.
   */
  function waitToLoadMap() {

    if (document.getElementById('gps-container').children.length !== 0) {

      vm.showExtendedGPS = !vm.showExtendedGPS;
      vm.showSpinner = false;
      $scope.$apply();
      setMapFocus();

    } else {

      $timeout(waitToLoadMap);

    }

  }

  window.bingmapsCallback = () => {

    if (window.Microsoft) {

      vm.showMapError = false;
      const mapElement = document.getElementById('gps-container');
      const mapPosition = applicationModel.trackingDetails.mailPieces.position;
      const latlong = `<span class="coordinates">${configService.messages.gps.coordinates}</span><br>
        <span class="latlong">${mapPosition.latitude}, ${mapPosition.longitude}</span>`;
      // eslint-disable-next-line no-undef
      const mapCenter = new Microsoft.Maps.Location(mapPosition.latitude, mapPosition.longitude);
      // eslint-disable-next-line no-undef
      defaultPin = new Microsoft.Maps.Pushpin(mapCenter,
        {
          icon: "<svg width='43px' height='64px' viewBox='0 0 43 64' version='1.1' xmlns='http://www.w3.org/2000/svg'><g id='01-Atoms-/-09-Map-/-Pin-/-Generic-/-Default' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><path d='M21.4951804,2 C10.7279286,2 2,10.7960267 2,21.6430772 C2,25.625419 3.51452481,29.4041664 4.28067417,30.8547756 C9.42294895,42.3408859 21.4951804,61.1724138 21.4951804,61.1724138 C21.4951804,61.1724138 33.5674118,42.3399434 38.710622,30.8519479 C39.4749004,29.405109 40.8687497,25.625419 40.9912962,21.6421347 C41.3205814,10.8016821 32.2614966,2 21.4951804,2 Z' id='Shape' stroke='#EBECE2' stroke-width='2' fill='{color}'></path></g></svg>",
          color: '#DA202A'
        }
      );
      // eslint-disable-next-line no-undef
      map = new Microsoft.Maps.Map(mapElement, {
        credentials: vm.configService.bingMapConfig.key,
        showMapTypeSelector: false,
        showLocateMeButton: false,
        showDashboard: true,
        enableSearchLogo: true,
        showBreadcrumb: true,
        center: mapCenter,
        minZoom: vm.configService.bingMapConfig.minZoom,
        disableZooming: true,
        disablePanning: true
      });
      // eslint-disable-next-line no-undef
      infobox = new Microsoft.Maps.Infobox(defaultPin.getLocation(),
        {
          description: latlong,
          offset: new Microsoft.Maps.Point(-10, 90) // eslint-disable-line no-undef
          // Adjusting the tooltip\infobox positions(left, top) to show above the pushpin.
        }
      );
      // eslint-disable-next-line no-undef
      Microsoft.Maps.Events.addHandler(defaultPin, 'click', () => {

        infobox.setOptions({ visible: true });

      });
      map.entities.push(defaultPin);
      infobox.setMap(map);
      waitToLoadMap();

    }

  };

  /**
   * Loads the Bingmap script
   * @param {String} url
   * @param {String} Key
   */
  function loadBingMapScript(url, Key) {

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `${url}?key=${Key}&callback=bingmapsCallback`;
    document.head.appendChild(script);
    script.onerror = () => {

      vm.showMapError = true;
      vm.showSpinner = false;
      $scope.$apply();

    };

  }

  /**
   * Toggles the GPS Map.
   */
  function toggleMap() {

    const mapElement = document.getElementById('gps-container');
    if (!vm.showExtendedGPS &&
      mapElement.children.length === 0) {

      vm.showSpinner = true;
      const key = vm.configService.bingMapConfig.key;
      const url = vm.configService.bingMapConfig.url;
      loadBingMapScript(url, key);

      const tags = {};
      tags.mapView = {
        eventName: 'map_view',
        link_name: 'view_on_map'
      };
      tealiumService.sendTags(tags.mapView, 'link');

    } else {

      vm.showExtendedGPS = !vm.showExtendedGPS;

    }

    // Set the focus on the map when the map is displayed
    $timeout(setMapFocus);

  }

  /**
   * Handle key enter event for toggling map display.
   * @param {Event} event
   */
  function toggleMapWithEnter(event) {

    if (event.keyCode === 13) {

      event.preventDefault();
      toggleMap();

    }

  }

  /**
   * Get the text to display for the GPS Map link.
   * @returns {String} The message to display.
   */
  function getMapLinkText() {

    if (vm.showExtendedGPS) {

      return vm.configService.messages.gps.close_map_link_text;

    }

    return vm.configService.messages.gps.show_on_map_link_text;

  }

  /**
   * Gets the information text based on Event Code.
   */
  function getInformationText() {

    return eventTypeService.getEventTypeText(applicationModel.trackingDetails.mailPieces.events);

  }

  vm.configService = configService;
  vm.getGPSToggleClass = getGPSToggleClass;
  vm.toggleMap = toggleMap;
  vm.toggleMapWithEnter = toggleMapWithEnter;
  vm.getMapLinkText = getMapLinkText;
  vm.showExtendedGPS = false;
  vm.showMapError = false;
  vm.getInformationText = getInformationText;
  vm.showSpinner = false;

}

export default gpsMapController;


// WEBPACK FOOTER //
// ./src/components/gpsMap/gpsMap.controller.js